import { type TCollectionType } from '@core/models'

// Display label for a collection's type badge (audio-web `COLLECTION_TYPES`). `liked` reads as
// "Collection" like the audio-web map.
export const COLLECTION_TYPE_LABELS: Record<TCollectionType, string> = {
    album: 'Album',
    audiobook: 'Audiobook',
    collection: 'Collection',
    draft: 'Draft',
    folder: 'Folder',
    mixtape: 'Mixtape',
    other: 'Other',
    playlist: 'Playlist',
    project: 'Project',
    liked: 'Collection',
    single: 'Single',
}
